import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { adminMcpServersQueryKey } from "./useAdminMcpServers";

interface CopyAllowedToolsArgs {
  serverId: string;
  sourceServerId: string;
}

export function useAdminCopyAllowedTools() {
  const { mcpRegistryService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ serverId, sourceServerId }: CopyAllowedToolsArgs) =>
      mcpRegistryService.adminCopyAllowedTools(serverId, sourceServerId),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: adminMcpServersQueryKey,
      });
    },
  });
}
